module.exports = __webpack_public_path__ + "img/banner.62e65046.png";